export const SAVE = 'stepBaggageAndPersonalItemsStarr.SAVE';
export const VALUE_CHANGED = 'stepBaggageAndPersonalItemsStarr.VALUE_CHANGED';
export const LOAD = 'stepBaggageAndPersonalItemsStarr.VALUE_LOAD';
export const NEXT = 'stepBaggageAndPersonalItemsStarr.NEXT';
export const RESET = 'stepBaggageAndPersonalItemsStarr.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'stepBaggageAndPersonalItemsStarr.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'stepBaggageAndPersonalItemsStarr.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'stepBaggageAndPersonalItemsStarr.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_AIRLINE_FOR_DAMAGED_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_AIRLINE_FOR_DAMAGED_STATE';
export const RESET_AIRLINE_BAGGAGE_DELAY_STATE = 'stepBaggageAndPersonalItemsStarr.RESET_AIRLINE_BAGGAGE_DELAY_STATE';

export const GET_FLIGHT_STATUS_REQUEST = 'stepBaggageAndPersonalItemsStarr.GET_FLIGHT_STATUS_REQUEST';
export const GET_FLIGHT_STATUS_SUCCESS = 'stepBaggageAndPersonalItemsStarr.GET_FLIGHT_STATUS_SUCCESS';
export const GET_FLIGHT_STATUS_ERROR = 'stepBaggageAndPersonalItemsStarr.GET_FLIGHT_STATUS_ERROR';

export const CURRENT_STEP_NAME = 'Trawick.Starr.StepBaggageAndPersonalItems';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '19',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/constants.js